import styled, { css } from "styled-components/macro";

import { ReactComponent as IconClose } from "../../assets/icons/icon_close.svg";

export const customScrollbar = css`
  &::-webkit-scrollbar {
    position: relative;
    width: 4px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #A7A7A7;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: lightgray;
    border-radius: 10px;
  }
`

export const Overlay = styled.div`
  all: unset;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
`;

export const Popup = styled.section`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 872px;
  width: 90%;
  background-color: #F8F8F8;
  border-radius: 24px;
  padding: 60px;
  z-index: 1001;
  outline: none;

  @media (max-width: 979px) {
    width: 100%;
    padding: 60px 12px 12px;
    min-height: 100dvh;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Tag = styled.div`
  background-color: #BFDCF5;
  padding: 8px 16px;
  border-radius: 22px;
  font-size: 16px;
  line-height: 16px;
  display: inline-block;
  margin-bottom: 14px;
  font-weight: 500;

  @media (max-width: 979px) {
    font-size: 14px;
    margin-bottom: 14px;
  }
`;

export const Title = styled.h2`
  font-size: 35px;
  font-family: "Cormorant Infant", sans-serif;
  margin-bottom: 40px;

  @media (max-width: 979px) {
    font-size: 30px;
    margin-bottom: 24px;
    text-align: center;
  }
`;

export const Text = styled.p`
  background-color: #fff;
  padding: 32px 40px;
  border-radius: 16px;
  font-size: 18px;
  margin-bottom: 40px;
  max-height: 350px;
  overflow: auto;
  line-height: 140%;

  ${customScrollbar};

  @media (max-width: 979px) {
    padding: 24px;
    max-height: 60dvh;
    margin-bottom: 0;
  }
`;

export const Author = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  
  @media (max-width: 979px) {
    justify-content: flex-start;
    width: 100%;
  }
  
`;

export const Name = styled.span`
  font-size: 18px;
  color: #A7A7A7;
  font-weight: 400;
  line-height: 25px;

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const Job = styled.span`
  font-size: 18px;
  font-weight: 400;

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const ProfileLink = styled.a`
  font-size: 18px;
  color: #55749F;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 28px;
  margin-left: auto;

  @media (max-width: 979px) {
    font-size: 16px;
  }
`;

export const CLoseContainer = styled.div`
  padding: 15px;
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
`

export const Close = styled(IconClose)`
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: 0.2s;
  
  path {
    stroke: #141414;
  }
  
  &:hover {
    transition: 0.2s;
    transform: scale(1.2);
  }
`
